import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type TerminateUserMutationVariables = Types.Exact<{
  userId: Types.Scalars['bigint']['input'];
}>;


export type TerminateUserMutation = { __typename?: 'mutation_root', update_users?: { __typename?: 'users_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'users', id: number, active: boolean }> } | null };


export const TerminateUserDocument = gql`
    mutation terminateUser($userId: bigint!) {
  update_users(where: {id: {_eq: $userId}}, _set: {active: false}) {
    affected_rows
    returning {
      id
      active
    }
  }
}
    `;
export type TerminateUserMutationFn = Apollo.MutationFunction<TerminateUserMutation, TerminateUserMutationVariables>;

/**
 * __useTerminateUserMutation__
 *
 * To run a mutation, you first call `useTerminateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTerminateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [terminateUserMutation, { data, loading, error }] = useTerminateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useTerminateUserMutation(baseOptions?: Apollo.MutationHookOptions<TerminateUserMutation, TerminateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TerminateUserMutation, TerminateUserMutationVariables>(TerminateUserDocument, options);
      }
export type TerminateUserMutationHookResult = ReturnType<typeof useTerminateUserMutation>;
export type TerminateUserMutationResult = Apollo.MutationResult<TerminateUserMutation>;
export type TerminateUserMutationOptions = Apollo.BaseMutationOptions<TerminateUserMutation, TerminateUserMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/userManagement/queries/terminateUser.mutation.gql}
 */
export async function terminateUser(
  variables: TerminateUserMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<TerminateUserMutation['update_users']>
export async function terminateUser(
  variables: TerminateUserMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<TerminateUserMutation>
export async function terminateUser(
  variables: TerminateUserMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<TerminateUserMutation['update_users'] | TerminateUserMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<TerminateUserMutation>(
    TerminateUserDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_users
}